module.exports = __webpack_public_path__ + "static/fonts/Material-Design-Iconic-Font.b351bd6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/mdi-font/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module id = 5zzy
// module chunks = 2